import React from 'react';

const Search = React.lazy(() => import(/* webpackChunkName: "search" */ './Search'));
const ChargingMap = React.lazy(() => import(/* webpackChunkName: "map" */ './ChargingMap'));

const baseUrl = '';

const pages = [
  {
    path: `/locations`,
    exact: true,
    component: Search,
  },
  {
    path: `${baseUrl}`,
    exact: false,
    component: ChargingMap,
  },
];

export default pages;
